export const ENTITY_DETAIL_OVERVIEW_SLOT = 'entity-detail-overview';
